import { AppLayout } from '@/components/layout/app-layout';
import { Sidebar } from "@/components/layout/sidebar";
import { PageHeader } from "@/components/layout/page-header";
import { StrategicUploadOverview } from "@/components/file-monitor/strategic-upload-overview";
import { PortfolioUploadStatus } from "@/components/file-monitor/portfolio-upload-status";
import { TeamPerformanceChart } from "@/components/file-monitor/team-performance-chart";
import { QualityOversight } from "@/components/file-monitor/quality-oversight";

const FileMonitor = () => {
  return (
    <AppLayout>
      <Sidebar />
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-y-auto">

        <StrategicUploadOverview />
        <PortfolioUploadStatus />
        
        <section className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <TeamPerformanceChart />
          <QualityOversight />
        </section>
        
        <footer className="mt-8 pt-6 border-t border-brand-border flex justify-between items-center">
          <p className="text-xs text-brand-text-primary">Copyright © 2024 Swiss Finance OS</p>
          <div className="flex items-center gap-4 text-xs text-brand-text-secondary">
            <span className="hover:text-brand-primary cursor-pointer">Privacy Policy</span>
            <span className="hover:text-brand-primary cursor-pointer">Terms & Conditions</span>
            <span className="hover:text-brand-primary cursor-pointer">Contact</span>
          </div>
        </footer>
      </main>
    </AppLayout>
  );
};

export default FileMonitor;